class CollectionTileResizer extends HTMLElement {
  constructor() {
    super();
    this.resizeObserver = new ResizeObserver(() => this.updateTileHeight());
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    window.addEventListener('resize', this.handleResize);
    this.observeTileBodies();
    this.updateTileHeight();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    this.resizeObserver.disconnect();
  }

  handleResize() {
    this.updateTileHeight();
  }

  observeTileBodies() {
    const tileBodies = this.getFollowingTileBodies();
    tileBodies.forEach((el) => this.resizeObserver.observe(el));
  }

  getFollowingTileBodies() {
    const bodies = [];
    let el = this.nextElementSibling;

    while (el && bodies.length < 2) {
      const body = el.querySelector('.product-item__body');
      if (body) bodies.push(body);
      el = el.nextElementSibling;
    }

    return bodies;
  }

  updateTileHeight() {
    const tileBodies = this.getFollowingTileBodies();
    const maxHeight = tileBodies.reduce((acc, el) => {
      const height = el.getBoundingClientRect().height;
      return Math.max(acc, height);
    }, 0);

    this.style.setProperty('--tile-body-height', `${Math.ceil(maxHeight)}px`);
  }
}

customElements.define('collection-tile-resizer', CollectionTileResizer);
